export default "__VITE_ASSET__de33c10e__"